import { Box, styled } from '@mui/material';

export const StyledVisibleSlider = styled(Box)(({ theme }) => ({
  display: 'none',
  '@media only screen and (max-width: 821px)': {
    display: 'block',
  },
}));

export const StyledSliderMobile = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  //paddingInline: '3px 27px',
  height: '100%',
  outline: 'none',
  '& > img': {
    maxWidth: '100%',
    objectFit: 'cover',
    cursor: 'pointer',
    minWidth: '100%',
    height: '100%',
  },
}));

export const StyledSliders = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  '@media only screen and (max-width: 821px)': {
    display: 'none',
  },
}));

export const StyledSlider1 = styled('div')(({ theme }) => ({
  width: '589px',
  maxWidth: '100%',
  '@media only screen and (max-width: 821px)': {
    width: '350px',
  },
}));

export const StyledSlider2 = styled('div')(({ theme }) => ({
  minHeight: '100px',
  width: '108px',

  overflow: 'hidden',
  marginRight: '16px',

  '& .slick-list': {
    maxHeight: '90vh',
  },
}));

export const StyledNextSliderButton = styled('button')(({ theme }) => ({
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  backgroundColor: 'transparent',
  border: '0',
  outline: 'none',
  cursor: 'pointer',
}));

export const StyledSlideItem = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  //paddingInline: '3px 27px',
  outline: 'none',
  '& > img': {
    maxWidth: '100%',
    objectFit: 'cover',
    cursor: 'pointer',
    minWidth: '100%',
    height: '805px',
    maxHeight: '805px',
    '@media only screen and (max-width: 821px)': {
      height: '536px',
    },
  },
}));

export const StyledLoaderDiv = styled('div')(({ theme }) => ({
  margin: '50% 45% 50% 46%',
  '@media only screen and (max-width: 768px)': {
    margin: '50% 45% 50% 40%',
  },
}));

export const StyledModal = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  width: '70%',
  marginY: 'auto',
  padding: '0 12px 0 40px',
  overflow: 'visible',
  outline: 'none',
  '& > .slick-slider': {
    touchAction: 'pinch-zoom',
  },
  '& .slick-prev:before': {
    content: "' '",
  },
  '& .slick-next:before': {
    content: "' '",
  },
  '& .slick-next': {
    zIndex: 1,
    right: '0%',
  },
  '& .slick-prev': {
    zIndex: 1,
    left: '-15px',
  },
  '@media only screen and (max-width: 1300px)': {
    width: '59%',
    padding: '0 15px 0 15px',
  },
  '@media only screen and (max-width: 1100px)': {
    width: '60%',
  },
  '@media only screen and (max-width: 900px)': {
    width: '100%',
  },
}));

export const StyledSlideItemModal = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  outline: 'none',
  touchAction: 'pinch-zoom !important',
  '& > img': {
    maxWidth: '100%',
    objectFit: 'contain',
    cursor: 'pointer',
    minWidth: '100%',
    height: '95vh',
    maxHeight: '100vh',
    '@media only screen and (max-width: 821px)': {
      objectFit: 'cover',
      height: '82vh',
    },
  },
}));

export const StyledButton = styled('span')(({ theme }) => ({
  padding: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 'fit-content',
  height: 'fit-content',
  borderRadius: '4px',
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
}));
